import React, { useMemo } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import Window from './Window';
import * as ProductReturnWindowConfig from '../../ProductReturnWindowConfig';
import { useProductReturnWindows } from '../context';

export default function List() {
  const { skuWindows, onReload } = useProductReturnWindows();

  const windows = useMemo(() => {
    return skuWindows.map(data => {
      const id = _get(data, 'id');
      return <Window key={id} data={data} />;
    });
  }, [skuWindows]);

  if (!windows.length) {
    return (
      <UiKit.Flex direction="column" gap={16} align="flex-start">
        <UiKit.Separator />
        <ProductReturnWindowConfig.Provider onSaved={onReload}>
          <ProductReturnWindowConfig.Trigger>
            Create Custom Return Window
          </ProductReturnWindowConfig.Trigger>
          <ProductReturnWindowConfig.Form />
        </ProductReturnWindowConfig.Provider>
      </UiKit.Flex>
    );
  }

  return (
    <UiKit.Flex direction="column" gap={24}>
      <UiKit.Flex direction="column" gap={8}>
        {windows}
      </UiKit.Flex>
      <ProductReturnWindowConfig.Provider onSaved={onReload}>
        <ProductReturnWindowConfig.Trigger className="mr-auto">
          Create Custom Return Window
        </ProductReturnWindowConfig.Trigger>
        <ProductReturnWindowConfig.Form />
      </ProductReturnWindowConfig.Provider>
    </UiKit.Flex>
  );
}
